<!-- 下拉/上拉刷新组件，支持自定义HTML模板 -->
<!-- 参考：mint-ui loadmore -->
<!-- 地址：http://mint-ui.github.io/docs/#/zh-cn2/loadmore -->
<template>
  <div class="compoment-loadmore-wrapper">
    <div
      class="compoment-loadmore"
      :style="transformStyle">
      <slot name="top">
        <div
          class="loadmore-loading"
          :style="topStyle">
          <div
            v-if="topStatus === 'loading'"
            class="loadmore-loading-img">
            <img
              :src="icons.Loading"
              alt="loading">
          </div>
          <circle-progress
            v-else
            :percentage="percentage"
            :width="width"
            :stoke-width="stokeWidth" />
        </div>
      </slot>
      <div :style="wrapperStyle">
        <slot></slot>
        <div
          v-if="bottomStatus === 'end'"
          class="loadmore-loading"
          :style="endStyle">
          <img class="end-img" :src="icons.Logo_Gray" alt="Logo_Blue">
        </div>
      </div>
      <slot name="bottom">
        <div
          v-if="bottomStatus === 'error'"
          class="loadmore-loading"
          :style="endStyle">
          <p>
            {{ $t('loaderror') }}<span @click="bottomRetry">{{ $t('retry') }}</span>
          </p>
        </div>
        <div
          v-else-if="bottomStatus !== 'end'"
          class="loadmore-loading"
          :style="bottomStyle">
          <div
            v-if="bottomStatus === 'loading'"
            class="loadmore-loading-img">
            <img
              :src="icons.Loading"
              alt="loading">
          </div>
          <circle-progress
            v-else
            :percentage="percentage"
            :width="width"
            :stoke-width="stokeWidth" />
        </div>
      </slot>
    </div>
  </div>
</template>
<script>
import { Loading, Logo_Gray } from '@/images'
import CircleProgress from './CircleProgress'
import mixins from '@/utils/mixins'
const Width = 22.5
const StokeWidth = 22.5
export default {
  components: {
    CircleProgress
  },
  mixins: [mixins],
  props: {
    // 下拉刷新执行的方法
    // eslint-disable-next-line
    topMethod: {
      type: Function
    },
    // 上拉刷新执行的方法，不传值表示不执行上拉操作
    // eslint-disable-next-line
    bottomMethod: {
      type: Function
    },
    // 下拉时提示区域文字，如'下拉刷新'
    topPullText: {
      type: String,
      default: ''
    },
    // 上拉时提示区域文字，如'释放更新'
    topDropText: {
      type: String,
      default: ''
    },
    // 下拉后，loading加载时提示文字，如'加载中...'
    topLoadingText: {
      type: String,
      default: ''
    },
    distanceIndex: {
      type: Number,
      default: 2
    },
    maxDistance: {
      type: Number,
      default: 0
    },
    topDistance: {
      type: Number,
      default: 80
    },
    topHeight: {
      type: Number,
      default: 64
    },
    bottomHeight: {
      type: Number,
      default: 73
    },
    bottomPullText: {
      type: String,
      default: ''
    },
    bottomDropText: {
      type: String,
      default: ''
    },
    bottomLoadingText: {
      type: String,
      default: ''
    },
    bottomDistance: {
      type: Number,
      default: 80
    },
    autoFill: {
      type: Boolean,
      default: false
    },
    // 内容区域样式设置，一般用于设置最小高度
    wrapperStyle: {
      type: Object,
      default () {
        return {
          minHeight: `100vh`
        }
      }
    }
  },
  data () {
    return {
      icons: {
        Loading,
        Logo_Gray
      },
      topText: '',
      topStatus: '',
      bottomText: '',
      bottomStatus: '',
      startY: 0,
      startScrollTop: 0,
      bottomReached: false,
      currentY: 0,
      translate: 0,
      direction: '',
      firstDirection: '',
      scrollEventTarget: null,
      percentage: 0,
      width: Width,
      stokeWidth: StokeWidth
    }
  },
  computed: {
    transformStyle () {
      const translate = this.translate === 0 ? null : `translate3d(0, ${this.translate}px, 0)`
      return {
        transform: translate
      }
    },
    // wrapperStyle () {
    //   return {
    //     minHeight: `100vh`
    //   }
    // },
    topStyle () {
      return {
        height: `${this.topHeight}px`,
        marginTop: `-${this.topHeight}px`
      }
    },
    bottomStyle () {
      return {
        height: `${this.bottomHeight}px`,
        marginBottom: `-${this.bottomHeight}px`
      }
    },
    endStyle () {
      return {
        height: `${this.bottomHeight}px`
      }
    },
    pullStyle () {
      return {
        transform: `rotate(${this.translate * 5}deg)`
      }
    }
  },
  watch: {
    topStatus (newVal) {
      this.$emit('top-status-change', newVal)
      switch (newVal) {
        case 'pull':
          this.topText = this.topPullText
          break
        case 'drop':
          this.topText = this.topDropText
          break
        case 'loading':
          this.topText = this.topLoadingText
          break
      }
    },
    translate (newVal) {
      const percentage = Math.abs(newVal) / this.topDistance * 100
      this.percentage = percentage > 100 ? 100 : percentage
      this.$emit('top-translate-change', newVal)
    }
  },
  mounted () {
    this.init()
  },
  methods: {
    // 下拉结束时，重新定位组件；需主动调用
    onTopEnd () {
      this.translate = 0
      setTimeout(() => {
        this.topStatus = 'pull'
      }, 200)
    },
    // 上拉结束时，重新定位组件；需主动调用
    onBottomEnd () {
      this.bottomStatus = 'pull'
      this.$nextTick(() => {
        this.scrollMove(this.bottomHeight)
        this.translate = 0
      })
    },
    // 上拉结束，且没有更多数据时，展示logo；需主动调用
    onBottomEmpty () {
      this.bottomStatus = 'end'
      this.$nextTick(() => {
        this.translate = 0
      })
    },
    // 上拉结束，且还有更多数据时，重置组件状态；需要主动调用
    onPull () {
      this.bottomStatus = 'pull'
    },
    // 上拉结束，且发生错误时，展示错误；需主动调用
    onBottomError () {
      this.bottomStatus = 'error'
      this.$nextTick(() => {
        this.scrollMove(this.bottomHeight)
        this.translate = 0
      })
    },
    scrollMove (num) {
      if (this.scrollEventTarget === window) {
        if (document.documentElement.scrollTop) {
          document.documentElement.scrollTop += num
        } else if (document.body.scrollTop) {
          document.body.scrollTop += num
        } else {
          document.documentElement.scrollTop += num
        }
      } else {
        this.scrollEventTarget.scrollTop += num
      }
    },
    getScrollEventTarget (element) {
      let currentNode = element
      while (currentNode && currentNode.tagName !== 'HTML' &&
        currentNode.tagName !== 'BODY' && currentNode.nodeType === 1) {
        const overflowY = document.defaultView.getComputedStyle(currentNode).overflowY
        if (overflowY === 'scroll' || overflowY === 'auto') {
          return currentNode
        }
        currentNode = currentNode.parentNode
      }
      return window
    },
    getScrollTop (element) {
      if (element === window) {
        return Math.max(window.pageYOffset || 0, document.documentElement.scrollTop)
      } else {
        return element.scrollTop
      }
    },
    checkBottomReached () {
      if (this.scrollEventTarget === window) {
        // 滚动条 + clientHeight + 2 >= srcollHeight
        // 判断滚动滑到底部，会有1px左右到误差
        return (document.documentElement.scrollTop || document.body.scrollTop) +
          document.documentElement.clientHeight + 2 >= document.body.scrollHeight
      } else {
        return parseInt(this.$el.getBoundingClientRect().bottom) <=
          parseInt(this.scrollEventTarget.getBoundingClientRect().bottom) + 1
      }
    },
    fillContainer () {
      if (this.autoFill) {
        this.$nextTick(() => {
          if (this.scrollEventTarget === window) {
            this.containerFilled = this.$el.getBoundingClientRect().bottom >=
              document.documentElement.getBoundingClientRect().bottom
          } else {
            this.containerFilled = this.$el.getBoundingClientRect().bottom >=
              this.scrollEventTarget.getBoundingClientRect().bottom
          }
          if (!this.containerFilled) {
            this.bottomStatus = 'loading'
            this.bottomMethod()
          }
        })
      }
    },
    bottomRetry () {
      this.translate = `-${this.bottomHeight}`
      this.bottomStatus = 'loading'
      this.bottomMethod()
    },
    bindTouchEvents () {
      this.$el.addEventListener('touchstart', this.handleTouchStart)
      this.$el.addEventListener('touchmove', this.handleTouchMove)
      this.$el.addEventListener('touchend', this.handleTouchEnd)
    },
    handleTouchStart (event) {
      this.startY = event.touches[0].clientY
      this.firstDirection = ''
      this.startScrollTop = this.getScrollTop(this.scrollEventTarget)
      if (this.topStatus !== 'loading') {
        this.topStatus = 'pull'
      }
    },
    handleTouchMove (event) {
      if (this.startY < this.$el.getBoundingClientRect().top &&
        this.startY > this.$el.getBoundingClientRect().bottom) {
        return
      }
      this.currentY = event.touches[0].clientY
      const distance = (this.currentY - this.startY) / this.distanceIndex
      this.direction = distance > 0 ? 'down' : 'up'
      this.firstDirection = this.firstDirection || this.direction
      if (typeof this.topMethod === 'function' && this.direction === 'down' &&
        this.getScrollTop(this.scrollEventTarget) === 0 && this.topStatus !== 'loading') {
        if (event.cancelable) {
          if (!event.defaultPrevented) {
            event.preventDefault()
            event.stopPropagation()
          }
        }
        if (this.maxDistance > 0) {
          this.translate = distance <= this.maxDistance
            ? distance - this.startScrollTop : this.translate
        } else {
          this.translate = distance - this.startScrollTop
        }
        if (this.translate < 0) {
          this.translate = 0
        }
        this.topStatus = this.translate >= this.topDistance ? 'drop' : 'pull'
      }
      if (this.direction === 'up') {
        this.bottomReached = this.bottomReached || this.checkBottomReached()
      }
      if (typeof this.bottomMethod === 'function' && this.direction === 'up' &&
        this.bottomReached && this.bottomStatus !== 'loading' &&
        this.bottomStatus !== 'error' && this.bottomStatus !== 'end') {
        if (event.cancelable) {
          if (!event.defaultPrevented) {
            event.preventDefault()
            event.stopPropagation()
          }
        }
        if (this.maxDistance > 0) {
          this.translate = Math.abs(distance) <= this.maxDistance
            ? this.getScrollTop(this.scrollEventTarget) - this.startScrollTop +
            distance : this.translate
        } else {
          this.translate = this.getScrollTop(this.scrollEventTarget) -
            this.startScrollTop + distance
        }
        if (this.translate > 0) {
          this.translate = 0
        }
        this.bottomStatus = -this.translate >= this.bottomDistance ? 'drop' : 'pull'
      }
    },
    handleTouchEnd (event) {
      if (this.direction === 'down' && this.getScrollTop(this.scrollEventTarget) === 0 &&
          this.translate > 0) {
        this.topDropped = true
        if (this.topStatus === 'drop') {
          this.translate = this.topHeight
          this.topStatus = 'loading'
          this.topMethod()
        } else {
          this.translate = 0
          this.topStatus = 'pull'
        }
      }
      if (this.direction === 'up' && this.bottomReached && this.translate < 0) {
        this.bottomReached = false
        if (this.bottomStatus === 'drop') {
          this.translate = `-${this.bottomHeight}`
          this.bottomStatus = 'loading'
          this.bottomMethod()
        } else {
          this.translate = '0'
          this.bottomStatus = 'pull'
        }
      }
      if (this.firstDirection === 'down' && event.changedTouches[0].clientY - this.startY < 0) {
        this.translate = 0
      }
    },
    getCircleProgressWidth () {
      setTimeout(() => {
        this.width = this.pxGo(Width)
        this.stokeWidth = this.pxGo(StokeWidth)
      }, 0)
    },
    init () {
      this.topStatus = 'pull'
      this.bottomStatus = 'pull'
      this.topText = this.topPullText
      this.scrollEventTarget = this.getScrollEventTarget(this.$el)
      this.getCircleProgressWidth()
      if (typeof this.topMethod === 'function') {
        this.fillContainer()
        this.bindTouchEvents()
      }
      if (typeof this.bottomMethod === 'function') {
        this.bindTouchEvents()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.compoment-loadmore-wrapper {
  overflow: hidden;
  .compoment-loadmore {
    .loadmore-loading {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: center;
      background: $color-stage1;
      .end-img {
        width: 111px;
        height: 18px;
      }
      .loadmore-loading-img {
        width: 22.5px;
        height: 22.5px;
        animation: rotation 1s infinite linear;
        img {
          width: 22.5px;
          height: 22.5px;
        }
      }
      p {
        color: $color-stage5;
        font-size: $little-font-size;
        line-height: 17px;
      }
      span {
        display: inline-block;
        color: $color-primary;
        font-size: $color-stage5;
        line-height: 17px;
      }
    }
  }
}
</style>
